<div class="highlighted_ticket {{status}}">
  <span class="highlighted_ticket__header">{% unsafe status_message %}</span>
  <div class="highlighted_ticket__ticket" role="highlighted_ticket_conteiner"></div>
</div>
